import React, { useState } from 'react';
import { FaTrash, FaTrashRestore } from 'react-icons/fa';
import { FiTrash2 } from 'react-icons/fi';

function Bin() {
  // Sample data for deleted documents
  const [documents, setDocuments] = useState([
    { id: 1, name: 'Document1.pdf' },
    { id: 2, name: 'Document2.docx' },
    { id: 3, name: 'Document3.xlsx' },
  ]);

  // Function to restore a document
  const restoreDocument = (id) => {
    // This will be replaced by backend integration in the future
    setDocuments(documents.filter(doc => doc.id !== id));
    alert(`Document with ID ${id} restored`);
  };

  // Function to empty the bin
  const emptyBin = () => {
    // This will be replaced by backend integration in the future
    setDocuments([]);
    alert('Bin emptied');
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h2 className="text-2xl font-bold mb-4 text-gray-800">Deleted Documents</h2>
      <div className="bg-white shadow-md rounded p-4">
        {documents.length > 0 ? (
          <ul className="space-y-4">
            {documents.map(doc => (
              <li key={doc.id} className="flex justify-between items-center border-b pb-2">
                <span className="text-gray-700">{doc.name}</span>
                <button 
                  onClick={() => restoreDocument(doc.id)} 
                  className="text-blue-500 hover:text-blue-700"
                >
                  <FaTrashRestore className="inline mr-2" /> Restore
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-600">No deleted documents.</p>
        )}
      </div>
      {documents.length > 0 && (
        <div className="mt-6 flex justify-end">
          <button 
            onClick={emptyBin} 
            className="bg-red-500 text-white px-4 py-2 rounded shadow hover:bg-red-600"
          >
            <FiTrash2 className="inline mr-2" /> Empty Bin
          </button>
        </div>
      )}
    </div>
  );
}

export default Bin;
